import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'
import { selectResourcesForKeyMetric } from 'redux/selectors/ResourceKeyMetricLinker'

export const useResourcesForKeyMetric = (keyMetricId: string) => {
  return useSelector((state: ApplicationState) =>
    selectResourcesForKeyMetric(state, keyMetricId))
}
